import { addLocaleData } from 'react-intl';
import hi from 'react-intl/locale-data/hi';
import kn from 'react-intl/locale-data/kn';
import as from 'react-intl/locale-data/as';
import bn from 'react-intl/locale-data/bn';
import tn from 'react-intl/locale-data/tn';
import te from 'react-intl/locale-data/te';
import ml from 'react-intl/locale-data/ml';
import gu from 'react-intl/locale-data/gu';
import mr from 'react-intl/locale-data/mr';

import { localeData, isRtl } from 'openblock-l10n';
import editorMessages from 'openblock-l10n/locales/editor-msgs';

addLocaleData([...localeData, ...hi, ...kn, ...as, ...bn, ...tn, ...te, ...ml, ...gu, ...mr]);

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

import hiMessages from '../translations/hi';
import knMessages from '../translations/kn';
import asMessages from '../translations/as';
import bnMessages from '../translations/bn';
import enMessages from '../translations/en';
import tnMessages from '../translations/tn';
import teMessages from '../translations/te';
import mlMessages from '../translations/ml';
import guMessages from '../translations/gu';
import mrMessages from '../translations/mr';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: Object.assign({}, editorMessages, {
        en: Object.assign({}, editorMessages.en, enMessages),
        hi: Object.assign({}, editorMessages.en, hiMessages),
        kn: Object.assign({}, editorMessages.en, knMessages),
        as: Object.assign({}, editorMessages.en, asMessages),
        bn: Object.assign({}, editorMessages.en, bnMessages),
        tn: Object.assign({}, editorMessages.en, tnMessages),
        te: Object.assign({}, editorMessages.en, teMessages),
        ml: Object.assign({}, editorMessages.en, mlMessages),
        gu: Object.assign({}, editorMessages.en, guMessages),
        mr: Object.assign({}, editorMessages.en, mrMessages)
    }),
    messages: Object.assign({}, editorMessages.en, enMessages)
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SELECT_LOCALE:
            return Object.assign({}, state, {
                isRtl: isRtl(action.locale),
                locale: action.locale,
                messagesByLocale: state.messagesByLocale,
                messages: state.messagesByLocale[action.locale]
            });
        case UPDATE_LOCALES:
            return Object.assign({}, state, {
                isRtl: state.isRtl,
                locale: state.locale,
                messagesByLocale: action.messagesByLocale,
                messages: action.messagesByLocale[state.locale]
            });
        default:
            return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (currentState.messagesByLocale.hasOwnProperty(locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
